import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { FilterSettings } from '../../model/filter-settings';
import { WidgetWrapper } from '../../model/widget-wrapper';
import { WidgetService } from '../../widget.service';
import { EntityName } from 'src/app/core/models/enumerations/entity-name';
import { Widget } from '../../model/widget';

@Component({
    selector: 'app-pending-release',
    standalone: false,
    templateUrl: './pending-release.component.html',

    providers: [DatePipe]
})
export class PendingReleaseComponent implements OnInit {
    public rows!: any[];
    public filterSettings!: FilterSettings;
    public widgetWrapper!: WidgetWrapper;
    @ViewChild('widgetDataContainer', { static: true })
    widgetDataContainer!: ElementRef;


    constructor(protected widgetService: WidgetService) { }

    ngOnInit(): void {
        this.filterSettings = {
            itemCount: String(this.widgetWrapper.widgetData.itemCount),
            entityType: this.widgetWrapper.widgetData.entitiesFilter ? this.widgetWrapper.widgetData.entitiesFilter : [],
            fiterEntities: Widget.getEntitySettings().map(x => ({ ...x}))
        }
        this.filterSettings.fiterEntities.forEach(ent => {
            if (this.filterSettings.entityType.includes(ent.id)) {
                ent.checked = true;
            } else {
                ent.checked = false;
            }
        });
        setTimeout(() => this.updateData());
    }

    public updateData(): void {
        this.widgetService.getRows(this, this.widgetWrapper.widgetData);
    }
    public saveSettings(): void {
        this.filterSettings.entityType = this.filterSettings.fiterEntities
            .filter(ent => ent.checked)
            .map(ent => ent.id);
        this.widgetService.saveWidget(this, this.filterSettings, this.widgetWrapper);
        this.widgetWrapper.showProperties = false;
    };

    // This exposes the enum to the template
    public get entityName(): typeof EntityName {
        return EntityName;
    }
}
